import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { StudioTemplate, RequestStatus, IStudioLibraryItem, Symbol, TextSymbol, Media, PricePointTemplate, AssetType, OfferTemplate, DocumentSegment, PageTemplate } from '@app/shared';
import { tap } from 'rxjs/operators';
import { StudioService } from '@app/core';
import { studioModes,studioAssetTypes } from '@app/shared/utils/studio-utils';
import { DomSanitizer} from '@angular/platform-browser';
import { StudioUtils, NGXLogger } from '@app/shared';
import {
  StudioActionTypes,

  CreateStudioTemplate,
  CreateStudioTemplateSuccess,

  GetStudioTemplate,
  GetStudioTemplateSuccess,

  GetStudioSymbols,
  GetStudioSymbolsSuccess,

  GetStudioPricePointTemplates,
  GetStudioPricePointTemplatesSuccess,

  GetStudioOfferTemplates,
  GetStudioOfferTemplatesSuccess,

  GetStudioSymbolTemplates,
  GetStudioSymbolTemplatesSuccess,

  EditDocumentSegment,
  EditDocumentSegmentSuccess,

  GetPageBackgrounds,
  GetPageBackgroundsSuccess,
  GetPageBackgroundsFailure,

  // GetPageDetailedInfo,
  // GetPageDetailedInfoSuccess,
  // GetPageDetailedInfoFailure,

  GetPageTemplates,
  GetPageTemplatesSuccess,
  GetPageTemplatesFailure,

  GetOfferTemplates,
  GetOfferTemplatesSuccess,
  GetOfferTemplatesFailure,

  AssignPageTemplate,
  AssignPageTemplateSuccess,
  AssignPageTemplateFailure,

  AssignOfferTemplate,
  AssignOfferTemplateSuccess,
  AssignOfferTemplateFailure,

  CheckFileExists,
  CheckFileExistsSuccess,
  CheckFileExistsFailure,

} from '../actions/studio.actions';


@Injectable()
export class StudioEffects {

  constructor(
    private actions: Actions,
    private studioService: StudioService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private studioUtils:StudioUtils,
    private logger:NGXLogger
  ) {}


  // effects go here
  @Effect()
  CreateStudioTemplate: Observable<any> = this.actions
    .ofType(StudioActionTypes.CREATE_STUDIO_TEMPLATE)
    .map((action: CreateStudioTemplate) => action.payload)
    .switchMap(payload => {

      return Observable.of(new CreateStudioTemplateSuccess(payload));

    });

    @Effect({ dispatch: false })
    CreateStudioTemplateSuccess: Observable<any> = this.actions.pipe(
      ofType(StudioActionTypes.CREATE_STUDIO_TEMPLATE_SUCCESS),
      tap((action) => {
        //localStorage.setItem('token', user.payload.token);
        this.router.navigateByUrl(`studio/${action.payload.studioTemplate.type.uriLoc}/create`);
      })
    );

    // Get Studio Template effect
    @Effect()
    GetStudioTemplate: Observable<any> = this.actions
      .ofType(StudioActionTypes.GET_STUDIO_TEMPLATE)
      .map((action: GetStudioTemplate) => action.payload)
      .switchMap(payload => {

        // create some symbols
        let template = payload.studioTemplate;
        return Observable.of(new GetStudioTemplateSuccess({studioTemplate:template,mode:payload.mode}));

      });

      @Effect({ dispatch: false })
      GetStudioTemplateSuccess: Observable<any> = this.actions.pipe(
        ofType(StudioActionTypes.GET_STUDIO_TEMPLATE_SUCCESS),
        tap((result) => {

          let uriPath;
          switch(result.payload.studioTemplate.type){

            case studioAssetTypes.STUDIO_SYMBOL:
              uriPath = 'symbol';
              break;

            case studioAssetTypes.PRICE_POINT_TEMPLATE:
              uriPath = 'pp';
              break;
          }
          //localStorage.setItem('token', user.payload.token);
          this.router.navigateByUrl(`studio/${result.payload.studioTemplate.type.uriLoc}/${result.payload.studioTemplate.id}`);
        })
      );

    // symbol effect
    @Effect()
    GetStudioSymbols: Observable<any> = this.actions
      .ofType(StudioActionTypes.GET_SYMBOLS)
      .map((action: GetStudioSymbols) => action.payload)
      .switchMap(payload => {

        // create some symbols
        let symbols = this.createSymbols();
        return Observable.of(new GetStudioSymbolsSuccess({symbolAssets:symbols}));

      });

      @Effect({ dispatch: false })
      GetStudioSymbolsSuccess: Observable<any> = this.actions.pipe(
        ofType(StudioActionTypes.GET_SYMBOLS_SUCCESS),
        tap((result) => {
          //localStorage.setItem('token', user.payload.token);
          //this.router.navigateByUrl('studio/pp/create');
        })
      );

      // pricepoints effect
      @Effect()
      GetStudioPricePointTemplates: Observable<any> = this.actions
        .ofType(StudioActionTypes.GET_PRICE_POINT_TEMPLATES)
        .map((action: GetStudioPricePointTemplates) => action.payload)
        .switchMap(payload => {
          let ppTemplates = this.createPricepoints();
          return Observable.of(new GetStudioPricePointTemplatesSuccess({pricepointAssets:ppTemplates}));

        });

        @Effect({ dispatch: false })
        GetStudioPricePointTemplatesSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_PRICE_POINT_TEMPLATES),
          tap((result) => {
            //localStorage.setItem('token', user.payload.token);
            //this.router.navigateByUrl('studio/pp/create');
          })
        );


        // offertemplates effect
        @Effect()
        GetStudioOfferTemplates: Observable<any> = this.actions
          .ofType(StudioActionTypes.GET_OFFER_TEMPLATES)
          .map((action: GetStudioOfferTemplates) => action.payload)
          .switchMap(payload => {
            let otTemplates = this.createOfferTemplates();
            return Observable.of(new GetStudioOfferTemplatesSuccess({offerTemplateAssets:otTemplates}));
        });

        @Effect({ dispatch: false })
        GetStudioOfferTemplatesSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_OFFER_TEMPLATES_SUCCESS),
          tap((result) => {
            //localStorage.setItem('token', user.payload.token);
            //this.router.navigateByUrl('studio/pp/create');
          })
        );

        // symbol templates effect
        @Effect()
        GetStudioSymbolTemplates: Observable<any> = this.actions
          .ofType(StudioActionTypes.GET_SYMBOL_TEMPLATES)
          .map((action: GetStudioSymbolTemplates) => action.payload)
          .switchMap(payload => {
            let symbols = this.createSymbolTemplates();
            return Observable.of(new GetStudioSymbolTemplatesSuccess({symbolTemplateAssets:symbols}));
        });

        @Effect({ dispatch: false })
        GetStudioSymbolTemplatesSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_SYMBOL_TEMPLATES_SUCCESS),
          tap((result) => {
            //localStorage.setItem('token', user.payload.token);
            //this.router.navigateByUrl('studio/pp/create');
          })
        );


        // symbol templates effect
        @Effect()
        EditDocumentSegment: Observable<any> = this.actions
          .ofType(StudioActionTypes.EDIT_DOCUMENT_SEGMENT)
          .map((action: GetStudioSymbolTemplates) => action.payload)
          .switchMap(payload => {
            //let symbols = this.createSymbolTemplates();
            return Observable.of(new EditDocumentSegmentSuccess({documentSegment:payload.documentSegment,job:payload.job,project:payload.project}));
        });

        @Effect({ dispatch: false })
        EditDocumentSegmentSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.EDIT_DOCUMENT_SEGMENT_SUCCESS),
          tap((result) => {
            //localStorage.setItem('token', user.payload.token);
            this.router.navigateByUrl(`studio/segment/${result.payload.documentSegment.uuid}?project=${result.payload.project.uuid}&job=${result.payload.job.uuid}`);
          })
        );

        // PAGE BACKGROUNDS
        @Effect()
        GetPageBackgrounds: Observable<any> = this.actions
            .ofType(StudioActionTypes.GET_PAGE_BACKGROUNDS)
            .map((action: GetPageBackgrounds) => action.payload)
            .debounceTime(10)
            .switchMap(payload => {
              return this.studioService.getPageBackgrounds()
                .map((result) => {
                  this.logger.debug(result.data);
                  //return new LogInSuccess({token: user.token, email: payload.email});
                  return new GetPageBackgroundsSuccess({pageBackgrounds:result.data})
                })
                .catch((error) => {
                  let es:RequestStatus = new RequestStatus();
                  es.msg = 'Problem fetching the Page Backgrounds';
                  return Observable.of(new GetPageBackgroundsFailure({ error: es }));
                });
            });


        @Effect({ dispatch: false })
        GetPageBackgroundsSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        @Effect({ dispatch: false })
        GetPageBackgroundsFailure: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_PAGE_BACKGROUNDS_FAILURE),
        );

        // Page Templates
        @Effect()
        GetPageTemplates: Observable<any> = this.actions
            .ofType(StudioActionTypes.GET_PAGE_TEMPLATES)
            .map((action: GetPageTemplates) => action.payload)
            .debounceTime(10)
            .switchMap(payload => {
              return this.studioService.getPageTemplates()
                .map((result) => {
                  this.logger.debug(result.data);
                  //return new LogInSuccess({token: user.token, email: payload.email});
                  let arr = [];
                  result.data.map(pt =>{
                    let val:PageTemplate = Object.assign( new PageTemplate(), pt );
                    val.grid = [];
                    if(!pt.payload && pt.rJson)
                      val.grid = this.studioUtils.convertToGridsterArray(pt.rJson);

                    arr.push(val);
                  })

                  return new GetPageTemplatesSuccess({pageTemplates:arr})
                })
                .catch((error) => {
                  let es:RequestStatus = new RequestStatus();
                  es.msg = 'Problem fetching the Page Templates';
                  return Observable.of(new GetPageTemplatesFailure({ errorStatus: es }));
                });
            });


        @Effect({ dispatch: false })
        GetPageTemplatesSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_PAGE_TEMPLATES_SUCCESS),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        @Effect({ dispatch: false })
        GetPageTemplatesFailure: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_PAGE_TEMPLATES_FAILURE),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        // Offer Templates
        @Effect()
        GetOfferTemplates: Observable<any> = this.actions
            .ofType(StudioActionTypes.GET_OFFER_TEMPLATES)
            .map((action: GetOfferTemplates) => action.payload)
            .debounceTime(10)
            .switchMap(payload => {
              return this.studioService.getOfferTemplates()
                .map((result) => {

                  this.logger.debug('result GET OFFER TEMPLATE')
                  if(result.success && !result.success){
                    let es:RequestStatus = new RequestStatus();
                    es.msg = result.success.message;
                    return Observable.of(new GetOfferTemplatesFailure({ error: es }));
                  }else{
                      let arr = [];
                      result.data.map(ot =>{
                        let val:OfferTemplate = Object.assign( new OfferTemplate(), ot );
                        arr.push(val);
                      })
                      return new GetOfferTemplatesSuccess({offerTemplates:arr})
                  }

                })
                .catch((error) => {
                  let es:RequestStatus = new RequestStatus();
                  es.msg = 'Problem fetching the Offer Templates';
                  return Observable.of(new GetOfferTemplatesFailure({ errorStatus: es }));
                });
            });


        @Effect({ dispatch: false })
        GetOfferTemplatesSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_OFFER_TEMPLATES_SUCCESS),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        @Effect({ dispatch: false })
        GetOfferTemplatesFailure: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_OFFER_TEMPLATES_FAILURE),
        );


        // Assigning page Templates
        @Effect()
        AssignPageTemplate: Observable<any> = this.actions
            .ofType(StudioActionTypes.ASSIGN_PAGE_TEMPLATE)
            .map((action: AssignPageTemplate) => action.payload)
            .debounceTime(10)
            .switchMap(payload => {
              return this.studioService.assignPageTemplate(payload.documentSegment.uuid,payload.pageTemplate.uuid)
                .map((result) => {

                  let template : PageTemplate = result.data[0];
                  let rs : RequestStatus = new RequestStatus();

                  rs.code = result.code;
                  rs.msg = `Template has been assigned`;
                  //return new LogInSuccess({token: user.token, email: payload.email});
                  return new AssignPageTemplateSuccess({successStatus:rs, pageTemplate:template})

                })
                .catch((error) => {
                  let es:RequestStatus = new RequestStatus();
                  es.msg = 'Problem Assigning Page Template';
                  return Observable.of(new AssignPageTemplateFailure({ errorStatus: es }));
                });
            });


        @Effect({ dispatch: false })
        AssignPageTemplateSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.ASSIGN_PAGE_TEMPLATE_SUCCESS),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        @Effect({ dispatch: false })
        AssignPageTemplateFailure: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.ASSIGN_PAGE_TEMPLATE_FAILURE),
        );


        // Assigning page Templates
        @Effect()
        AssignOfferTemplate: Observable<any> = this.actions
            .ofType(StudioActionTypes.ASSIGN_OFFER_TEMPLATE)
            .map((action: AssignOfferTemplate) => action.payload)
            .debounceTime(10)
            .switchMap(payload => {
              return this.studioService.assignOfferTemplate(payload.offerTemplate.uuid, payload.offer.uuid)
                .map((result) => {

                  if(result.data && result.data[0] === 'success'){

                    let template : OfferTemplate = result.data[0];
                    let rs : RequestStatus = new RequestStatus();

                    rs.code = result.code;
                    rs.msg = `Template has been assigned`;

                    return new AssignOfferTemplateSuccess({successStatus:rs, offerTemplate:template})

                  }else{
                    let es:RequestStatus = new RequestStatus();
                    es.msg = 'Problem Assigning Offer Template';
                    return Observable.of(new AssignOfferTemplateFailure({ error: es }));
                  }

                })
                .catch((error) => {
                  let es:RequestStatus = new RequestStatus();
                  es.msg = 'Problem Assigning Offer Template';
                  return Observable.of(new AssignOfferTemplateFailure({ errorStatus: es }));
                });
            });


        @Effect({ dispatch: false })
        AssignOfferTemplateSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.ASSIGN_OFFER_TEMPLATE_SUCCESS),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        @Effect({ dispatch: false })
        AssignOfferTemplateFailure: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.ASSIGN_OFFER_TEMPLATE_FAILURE),
        );


        // Offer Templates
        @Effect()
        CheckFileExists: Observable<any> = this.actions
            .ofType(StudioActionTypes.CHECK_FILE_EXISTS)
            .map((action: CheckFileExists) => action.payload)
            .debounceTime(10)
            .switchMap(payload => {


              return this.studioService.checkFileExists(payload.url)


                .map((response) => {

                  let rs : RequestStatus = new RequestStatus();

                  rs.code = response.code;
                  rs.msg = `File Exists`;

                  this.logger.debug('result GET FILE')
                  return new CheckFileExistsSuccess({successStatus:rs})
                  // if(result.success && !result.success){
                  //   let es:RequestStatus = new RequestStatus();
                  //   es.msg = result.success.message;
                  //   return Observable.of(new CheckFileExistsFailure({ error: es }));
                  // }else{
                  //   return new CheckFileExistsSuccess({successStatus:rs});
                  // }

                })
                .catch((error) => {
                  this.logger.debug('error')
                  let es:RequestStatus = new RequestStatus();
                  es.msg = 'Problem fetching the file';
                  return Observable.of(new CheckFileExistsFailure({ errorStatus: es }));
                })
                .toPromise();
            });


        @Effect({ dispatch: false })
        CheckFileExistsSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.CHECK_FILE_EXISTS_SUCCESS),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        @Effect({ dispatch: false })
        CheckFileExistsFailure: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.CHECK_FILE_EXISTS_FAILURE),
        );

        // PAGE DETAILED INFORMATION
        /*@Effect()
        GetPageDetailedInfo: Observable<any> = this.actions
            .ofType(StudioActionTypes.GET_PAGE_DETAILED_INFO)
            .map((action: GetPageDetailedInfo) => action.payload)
            .debounceTime(10)
            .switchMap(payload => {
              return this.studioService.getPageDetailedInfo(payload.documentSegment.uuid)
                .map((result) => {
                  this.logger.debug(result.data);
                  //return new LogInSuccess({token: user.token, email: payload.email});
                  return new GetPageDetailedInfoSuccess({page:result.data})
                })
                .catch((error) => {
                  let es:RequestStatus = new RequestStatus();
                  es.msg = error.statusText;
                  return Observable.of(new GetPageDetailedInfoFailure({ error: es }));
                });
            });


        @Effect({ dispatch: false })
        GetPageDetailedInfoSuccess: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_PAGE_DETAILED_INFO_SUCCESS),
          tap((result) => {
            this.logger.debug(result)
          })
        );

        @Effect({ dispatch: false })
        GetPageDetailedInfoFailure: Observable<any> = this.actions.pipe(
          ofType(StudioActionTypes.GET_PAGE_DETAILED_INFO_FAILURE),
        );*/

        createSymbolTemplates():Symbol[]{
          let stack = [];
          for(let i=0; i<8; i++){

            if(i%2){
              let symbol = new Symbol();
              symbol.id = i;
              symbol.name = 'Half Price';
              symbol.jsonSrc = 'assets/svg/symbols/ww/halfprice.json';
              symbol.svgSrc= "assets/svg/symbols/ww/halfprice.svg";
              symbol.type = studioAssetTypes.SYMBOL_TEMPLATE;
              stack.push(symbol);
            }else{
              let symbol = new Symbol();
              symbol.id = i;
              symbol.name = 'Special';
              symbol.jsonSrc = 'assets/svg/symbols/ww/special.json';
              symbol.svgSrc= "assets/svg/symbols/ww/special.svg";
              symbol.type = studioAssetTypes.SYMBOL_TEMPLATE;
              stack.push(symbol);
            }
          }

          return stack;
        }

        createSymbols():Symbol[]{
          let stack = [];
          let stockSym = ['rectangle','square','circle','triangle'];
          for(let i=0; i<stockSym.length; i++){
            let symbol = new Symbol();
            symbol.id = i+8;
            symbol.name = stockSym[i];
            symbol.jsonSrc = `assets/svg/symbols/${stockSym[i]}.json`;
            symbol.svgSrc= `assets/svg/symbols/${stockSym[i]}.svg`;
            symbol.type = studioAssetTypes.STUDIO_SYMBOL;
            stack.push(symbol);
          }

          // symbol = new Symbol();
          // symbol.id = 10;
          // symbol.name = stockSym[i];
          // symbol.jsonSrc = `assets/svg/symbols/ww/ppsymbol.json`;
          // symbol.svgSrc= `assets/svg/symbols/ww/ppsymbol.svg`;
          // symbol.type = studioAssetTypes.STUDIO_SYMBOL;
          // stack.push(symbol);

          // symbol = new Symbol();
          // symbol.id = 11;
          // symbol.name = stockSym[i];
          // symbol.jsonSrc = `assets/svg/symbols/ww/special.json`;
          // symbol.svgSrc= `assets/svg/symbols/ww/special.svg`;
          // symbol.type = studioAssetTypes.STUDIO_SYMBOL;
          // stack.push(symbol);

          return stack;
        }
        createPricepoints():PricePointTemplate[]{
          let stack = [];
          for(let i=0; i<8; i++){

            if(i%2){
              let symbol = new PricePointTemplate();
              symbol.id = i;
              symbol.name = 'Basic Price Point';
              symbol.jsonSrc = 'assets/svg/pp/ww/1.json';
              symbol.svgSrc= "assets/svg/pp/ww/1.svg";
              symbol.type = studioAssetTypes.PRICE_POINT_TEMPLATE;
              stack.push(symbol);
            }else{
              let symbol = new PricePointTemplate();
              symbol.id = i;
              symbol.name = 'Basic with FROM Price Point';
              symbol.jsonSrc = 'assets/svg/pp/ww/2.json';
              symbol.svgSrc= "assets/svg/pp/ww/2.svg";
              symbol.type = studioAssetTypes.PRICE_POINT_TEMPLATE;
              stack.push(symbol);
            }


          }

          return stack;
        }

        createOfferTemplates():OfferTemplate[]{
          let stack = [];
          for(let i=0; i<1; i++){


              let symbol = new OfferTemplate();
              symbol.id = i;
              symbol.name = 'Basic Offer Template';
              symbol.jsonSrc = 'assets/svg/ot/1.json';
              symbol.svgSrc= "assets/svg/ot/1.svg";
              symbol.type = studioAssetTypes.OFFER_TEMPLATE;
              stack.push(symbol);

          }
          for(let i=0; i<1; i++){
              let symbol = new OfferTemplate();
              symbol.id = i;
              symbol.name = 'Basic Offer Template 2';
              symbol.jsonSrc = 'assets/svg/ot/2.json';
              symbol.svgSrc= "assets/svg/ot/2.svg";
              symbol.type = studioAssetTypes.OFFER_TEMPLATE;
              stack.push(symbol);

          }
          this.logger.debug(stack)
          return stack;
        }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/studio.effects.ts